export enum PreviewDisplayType {
    Row = "Row",
    Square = "Square",
    Single = "Single",
    ArtistRadio = "ArtistRadio",
    Headline = "Headline"
}
